
module.config(function($stateProvider, TagUrl) {

    var program_url = new TagUrl()
        .addTagTypes(['program', 'location'])
        .removeTag('operating')
        .addSorterParams('name', 'asc')
        .addExtraParam('status', 'active')
        .addExtraParam('search', '')
        .addPagerParams();

    $stateProvider.state('programs', {
        parent: 'basic',
        url: program_url.buildUrl('/programs'),
        params: program_url.params,
        data: {tagUrl: program_url},
        permission: 'indexPrograms',
        templateUrl: 'programs/basic/index',
        controller: 'ProgramIndexController as ctrl',
        controllerAs: 'ctrl',
        reloadOnSearch: false,
    })

    .state('myPrograms', {
        parent: 'basic',
        url: '/my-programs',
        templateUrl: 'programs/basic/mine',
        resolve: {
            programs: function(ModelService) {
                return ModelService.index('program/mine');
            },
        },
        controllerAs: 'ctrl',
        controller: function(programs) { this.programs = programs; },
    })

    .state('program', {
        parent: 'basic',
        abstract: true,
        url: '/programs/:slug',
        resolve: {
            program: function($stateParams, ModelService) {
                return ModelService.getRelation(
                    'program', $stateParams.slug, 'summary');
            },
            permissions: function(ModelService, program) {
                return ModelService
                    .getModelRelation(program, 'permissions');
            },
            issues: function(program, IssueService) {
                return IssueService.loadIssues('program', program.id);
            },
        },
        views: {
            '': {
                templateUrl: 'programs/basic/base',
                controller: 'ProgramBaseController',
            },
            'contextNav@basic': {
                templateUrl: 'programs/menu',
                controller: 'ProgramBaseController',
            },
            'entityId@basic': {
                template: '<small>pid</small><span>{{ ::program.id }}</span>',
                controller: 'ProgramBaseController',
            }
        }
    })
});
